import { render, staticRenderFns } from "./TabDetailHistoryWorkRestriction.vue?vue&type=template&id=aad360d6&scoped=true"
import script from "./TabDetailHistoryWorkRestriction.vue?vue&type=script&lang=js"
export * from "./TabDetailHistoryWorkRestriction.vue?vue&type=script&lang=js"
import style0 from "./TabDetailHistoryWorkRestriction.vue?vue&type=style&index=0&id=aad360d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad360d6",
  null
  
)

export default component.exports